(() => {
  // Safeguards against a head/foot JS mismatch
  if (!window.swinger.focusableElements) {
    return;
  }

  const focusableElems = window.swinger.focusableElements;
  let activeCaptureElemStack = [];
  const centerOffsetThreshold = 150;
  const edgeOffsetThreshold = 10;
  const focusElement = (elem) => {
    if (document.activeElement.matches('[aria-activedescendant]')) {
      document.activeElement.setAttribute('aria-activedescendant', elem.id);

      switch (true) {
        default:
          elem.scrollIntoViewIfNeeded(false);
          break;

        case !elem.scrollIntoViewIfNeeded:
          elem.scrollIntoViewIfNeeded({
            behavior: 'instant',
            block: 'nearest',
            inline: 'nearest',
          });
          break;
      }
    } else {
      elem.focus({ focusVisible: true });
    }
  };
  function captureNavWithinHandler(e) {
    if (!activeCaptureElemStack.length) {
      return;
    }

    const activeCaptureElem = activeCaptureElemStack[activeCaptureElemStack.length - 1];
    const previousFocusedElem = window.swinger.eventHub.getTarget(e);
    const nextFocusedElem = e.relatedTarget;
    const focusableChildren = window.swinger.$(focusableElems.join(','), activeCaptureElem).filter((elem) => {
      if (elem.checkVisibility && !elem.checkVisibility({
        visibilityProperty: true,
      })) {
        return false;
      }
      return true;
    });

    if (!nextFocusedElem) {
      return;
    }

    if (
      !nextFocusedElem.matches(`[aria-controls="${activeCaptureElem.id}"]`)
      && focusableChildren.indexOf(nextFocusedElem) === -1
    ) {
      let newTargetElem;

      if (focusableChildren.indexOf(previousFocusedElem) === 0) {
        newTargetElem = focusableChildren[focusableChildren.length - 1];
      } else {
        newTargetElem = focusableChildren[0];
      }

      if (newTargetElem) {
        newTargetElem.focus();
      }
    }
  }
  window.addEventListener('focusout', captureNavWithinHandler, true);

  function toggleCaptureNav(elem, action) {
    activeCaptureElemStack = activeCaptureElemStack.filter((activeCaptureElem) => activeCaptureElem !== elem);

    switch (action) {
      default:
      case 'on':
        activeCaptureElemStack.push(elem);
        break;

      case 'off':
    }
  }

  const distance = (pointA, pointB) => {
    const a = pointA.x - pointB.x;
    const b = pointA.y - pointB.y;

    return Math.sqrt(a * a + b * b);
  };

  window.swinger = {
    ...window.swinger,
    navigationHelper: {
      captureNav: (elem) => {
        toggleCaptureNav(elem, 'on');
      },
      releaseNav: (elem) => {
        toggleCaptureNav(elem, 'off');
      },
      enableArrowNav: (selector, excludeSelector) => {
        window.swinger.eventHub.register('keydown', `${selector} *`, (e) => {
          switch (e.key) {
            default:
              return;

            case 'Up':
            case 'ArrowUp':
            case 'Down':
            case 'ArrowDown':
              break;

            case 'Left':
            case 'ArrowLeft':
              if (
                document.activeElement
                && document.activeElement.matches('input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"])')
                && document.activeElement.value
                && document.activeElement.selectionStart !== 0
              ) {
                return;
              }
              break;

            case 'Right':
            case 'ArrowRight':
              if (
                document.activeElement
                && document.activeElement.matches('input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"])')
                && document.activeElement.value
                && document.activeElement.selectionStart !== document.activeElement.value.length
              ) {
                return;
              }
              break;
          }

          const focusableChildrenCoords = window.WeakMap ? new WeakMap() : new Map();
          let isElemWithActiveDescendantLogicFocused = false;
          let controlledId;
          let potentialAriaDescendantChildren = [];

          if (document.activeElement.matches('[aria-activedescendant][aria-controls]')) {
            controlledId = document.activeElement.getAttribute('aria-controls');
            isElemWithActiveDescendantLogicFocused = !!(controlledId && document.getElementById(controlledId));
            potentialAriaDescendantChildren = window.swinger.$(`#${controlledId} [role="option"]`);
          }

          const focusableChildren = potentialAriaDescendantChildren.length ? potentialAriaDescendantChildren : window.swinger.$(focusableElems
            .map((subSelector) => `${selector} ${subSelector}`).join(','))
            .filter((elem) => (excludeSelector ? !elem.matches(excludeSelector) : true));

          if (focusableChildren.indexOf(document.activeElement) === -1) {
            focusableChildren.push(document.activeElement);
          }

          focusableChildren.forEach((elem) => {
            const rect = elem.getBoundingClientRect();
            const coords = {
              width: rect.width,
              height: rect.height,
              left: rect.left,
              right: rect.right,
              top: rect.top,
              bottom: rect.bottom,
              center: {
                x: rect.left + (rect.width / 2),
                y: rect.top + (rect.height / 2),
              },
            };

            focusableChildrenCoords.set(elem, coords);
          });

          const viewportWidth = window.innerWidth;
          const focusableVisibleChildren = focusableChildren
            .filter((elem) => {
              const coords = focusableChildrenCoords.get(elem);

              return !!(coords.width * coords.height)
                && coords.left < viewportWidth
                && coords.right > 0;
            });

          if (focusableVisibleChildren.length <= 1) {
            return;
          }

          const activeDescendantId = document.activeElement.getAttribute('aria-activedescendant');
          const activeElement = isElemWithActiveDescendantLogicFocused && activeDescendantId ? document.getElementById(activeDescendantId) : document.activeElement;
          const activeElementCoords = focusableChildrenCoords.get(activeElement);
          let focusableElemsInDirection;
          let distanceSort;

          switch (e.key) {
            default:
              return;

            case 'Down':
            case 'ArrowDown':
              focusableElemsInDirection = focusableVisibleChildren
                .filter((elem) => {
                  const elemCoords = focusableChildrenCoords.get(elem);

                  return elemCoords.top > activeElementCoords.bottom - edgeOffsetThreshold
                    && Math.abs(elemCoords.center.x - activeElementCoords.center.x) <= centerOffsetThreshold;
                });
              distanceSort = (a, b) => {
                const coordsA = focusableChildrenCoords.get(a);
                const coordsB = focusableChildrenCoords.get(b);
                const distanceA = distance({
                  x: coordsA.center.x,
                  y: coordsA.top,
                }, {
                  x: activeElementCoords.center.x,
                  y: activeElementCoords.bottom,
                });
                const distanceB = distance({
                  x: coordsB.center.x,
                  y: coordsB.top,
                }, {
                  x: activeElementCoords.center.x,
                  y: activeElementCoords.bottom,
                });

                if (coordsA.center.x !== coordsB.center.x) {
                  if (activeElementCoords.center.x === coordsA.center.x) {
                    return -1;
                  }
                  if (activeElementCoords.center.x === coordsB.center.x) {
                    return 1;
                  }
                }
                if (distanceA < distanceB) {
                  return -1;
                }
                if (distanceA > distanceB) {
                  return 1;
                }
                return 0;
              };
              break;

            case 'Up':
            case 'ArrowUp':
              focusableElemsInDirection = focusableVisibleChildren
                .filter((elem) => {
                  const elemCoords = focusableChildrenCoords.get(elem);

                  return elemCoords.bottom < activeElementCoords.top + edgeOffsetThreshold
                    && Math.abs(elemCoords.center.x - activeElementCoords.center.x) <= centerOffsetThreshold;
                });
              distanceSort = (a, b) => {
                const coordsA = focusableChildrenCoords.get(a);
                const coordsB = focusableChildrenCoords.get(b);
                const distanceA = distance({
                  x: coordsA.center.x,
                  y: coordsA.bottom,
                }, {
                  x: activeElementCoords.center.x,
                  y: activeElementCoords.top,
                });
                const distanceB = distance({
                  x: coordsB.center.x,
                  y: coordsB.bottom,
                }, {
                  x: activeElementCoords.center.x,
                  y: activeElementCoords.top,
                });

                if (coordsA.center.x !== coordsB.center.x) {
                  if (activeElementCoords.center.x === coordsA.center.x) {
                    return -1;
                  }
                  if (activeElementCoords.center.x === coordsB.center.x) {
                    return 1;
                  }
                }
                if (distanceA < distanceB) {
                  return -1;
                }
                if (distanceA > distanceB) {
                  return 1;
                }
                // a must be equal to b
                return 0;
              };
              break;

            case 'Left':
            case 'ArrowLeft':
              focusableElemsInDirection = focusableVisibleChildren
                .filter((elem) => {
                  const elemCoords = focusableChildrenCoords.get(elem);

                  return elemCoords.right < activeElementCoords.left + edgeOffsetThreshold
                    && elemCoords.center.y > activeElementCoords.center.y - edgeOffsetThreshold;
                });
              distanceSort = (a, b) => {
                const coordsA = focusableChildrenCoords.get(a);
                const coordsB = focusableChildrenCoords.get(b);
                const distanceA = distance({
                  x: coordsA.right,
                  y: coordsA.center.y,
                }, {
                  x: activeElementCoords.left,
                  y: activeElementCoords.center.y,
                });
                const distanceB = distance({
                  x: coordsB.right,
                  y: coordsB.center.y,
                }, {
                  x: activeElementCoords.left,
                  y: activeElementCoords.center.y,
                });

                if (distanceA < distanceB) {
                  return -1;
                }
                if (distanceA > distanceB) {
                  return 1;
                }
                // a must be equal to b
                return 0;
              };
              break;

            case 'Right':
            case 'ArrowRight':
              focusableElemsInDirection = focusableVisibleChildren
                .filter((elem) => {
                  const elemCoords = focusableChildrenCoords.get(elem);

                  return elemCoords.left > activeElementCoords.right - edgeOffsetThreshold
                    && elemCoords.center.y > activeElementCoords.center.y - edgeOffsetThreshold;
                });
              distanceSort = (a, b) => {
                const coordsA = focusableChildrenCoords.get(a);
                const coordsB = focusableChildrenCoords.get(b);
                const distanceA = distance({
                  x: coordsA.left,
                  y: coordsA.center.y,
                }, {
                  x: activeElementCoords.right,
                  y: activeElementCoords.center.y,
                });
                const distanceB = distance({
                  x: coordsB.left,
                  y: coordsB.center.y,
                }, {
                  x: activeElementCoords.right,
                  y: activeElementCoords.center.y,
                });

                if (distanceA < distanceB) {
                  return -1;
                }
                if (distanceA > distanceB) {
                  return 1;
                }
                // a must be equal to b
                return 0;
              };
              break;
          }

          if (!focusableElemsInDirection.length) {
            return;
          }

          const commonParent = document.activeElement.closest('ul, ol, nav, header, footer, aside, article, body');
          const commonParentElemsInDistance = focusableElemsInDirection.filter((elem) => commonParent.contains(elem));

          if (commonParentElemsInDistance.length) {
            focusableElemsInDirection = commonParentElemsInDistance;
          }

          focusableElemsInDirection.sort(distanceSort);

          if (isElemWithActiveDescendantLogicFocused) {
            const id = 'swinger-selected-activedescendant';
            const currentlyActiveDescendant = document.getElementById(id);

            if (currentlyActiveDescendant) {
              currentlyActiveDescendant.removeAttribute('id');
            }
            focusableElemsInDirection[0].setAttribute('id', id);
            focusElement(focusableElemsInDirection[0]);
          } else {
            focusableElemsInDirection[0].focus({ focusVisible: true });
          }

          e.preventDefault();
          e.stopImmediatePropagation();
        });
      },
    },
  };

  window.swinger.eventHub.register('keydown', '[aria-controls][aria-activedescendant]:not([aria-activedescendant=""]):focus', (e) => {
    if (e.key !== 'Enter') {
      return;
    }

    const input = window.swinger.eventHub.getTarget(e);
    const activeDescendantId = input.getAttribute('aria-activedescendant');
    const activeDescendant = document.getElementById(activeDescendantId);

    if (!activeDescendant) {
      return;
    }

    const activeDescendantButtonOrLink = activeDescendant.querySelector('button, a');

    (activeDescendantButtonOrLink || activeDescendant).click();

    e.preventDefault();
  });
})();
